import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { ResponsiveView } from 'receivable-invoices-js/react/components/shared/responsive-view';
import { Loading } from 'receivable-invoices-js/react/components/shared/loading';
import { useLocaleManager } from 'receivable-invoices-js/react/hooks/use-locale-manager';
import { useRouteQuery } from './use-route-query';

export function CreditNotesRoute(): ReactNode {
  const localeManager = useLocaleManager();
  const { creditNote, isLoading, isError } = useRouteQuery();

  useEffect(() => {
    if (creditNote?.locale) {
      localeManager.setLocale(creditNote.locale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- localeManager is a stable
  }, [creditNote]);

  if (isLoading) {
    return <Loading spinnerSize="large" />;
  }

  if (isError || !creditNote) {
    return <Navigate replace to="/error" />;
  }

  return (
    <ResponsiveView
      data-test-credit-note-responsive-view=""
      document={creditNote}
      type="credit-note"
    />
  );
}
